// Web Speech API wrapper for Read Aloud.
// Falls back gracefully when unsupported.

let currentUtterance = null;

export function ttsSupported() {
  return typeof window !== "undefined" && "speechSynthesis" in window;
}

export function speak(text, { onStart, onEnd, onError } = {}) {
  if (!ttsSupported()) {
    onError && onError(new Error("Read Aloud isn't available in this browser."));
    return;
  }
  stop();
  const u = new SpeechSynthesisUtterance(text);
  // Slow, gentle pace for seniors
  u.rate = 0.92;
  u.pitch = 1.0;
  u.volume = 1.0;
  // Prefer an English voice if available
  const voices = window.speechSynthesis.getVoices();
  const preferred = voices.find(
    (v) => /en(-|_)?US/i.test(v.lang) && /female|samantha|karen|jenny/i.test(v.name)
  ) || voices.find((v) => /^en/i.test(v.lang));
  if (preferred) u.voice = preferred;
  u.onstart = () => onStart && onStart();
  u.onend = () => onEnd && onEnd();
  u.onerror = (e) => onError && onError(e);
  currentUtterance = u;
  window.speechSynthesis.speak(u);
}

export function stop() {
  if (!ttsSupported()) return;
  try {
    window.speechSynthesis.cancel();
  } catch { /* noop */ }
  currentUtterance = null;
}

export function isSpeaking() {
  return ttsSupported() && window.speechSynthesis.speaking;
}
